import * as url from "helpers/url_helper/url_helper"
import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"

export const getCityDefinition = () => get(url.CITYDEF_DEFINITIONS)
export const addCityDefinition = record => post(url.CITYDEF_INSERT, record)
export const updateCityDefinition = record => put(url.CITYDEF_UPDATE, record)
export const deleteCityDefinition = guid => del(url.CITYDEF_DELETE, { params: { guid } })